import { createFileRoute } from '@tanstack/react-router';
import { Helmet } from 'react-helmet-async';
import { formatDocumentTitle } from '@/lib/document-title';
import { SameTimeZoneSetupPage } from './services/components/same-time-zone-setup/same-time-zone-setup-page';

/**
 * Same-time services (client switch + Hands / Feet / Neither per service) — `/settings/services/same-time`. The
 * trailing `_` in `services_` makes it its own full page instead of nesting inside the Services
 * settings layout.
 */
export const Route = createFileRoute('/_auth/$orgId/settings/services_/same-time')({
  component: ServicesSameTimeRoute,
});

function ServicesSameTimeRoute() {
  const { orgId } = Route.useParams();
  return (
    <>
      <Helmet>
        <title>{formatDocumentTitle('Same-time services', 'Services')}</title>
      </Helmet>
      {/* Keyed by salon: switching salon must never keep the previous salon's unsaved draft. */}
      <SameTimeZoneSetupPage key={orgId} routeOrgId={orgId} />
    </>
  );
}
